import { combineReducers } from "redux";

const generateLinkedinHeadshot = (state = {}, action) => {
    switch (action.type) {
        case "GENERATE_LINKEDIN_HEADSHOT_SUCCESS":
            return {
                isLoading: false,
                isError: false,
                isSuccess: true,
                generatedImage: action.payload.image,
                uuid: action.payload.uuid,
            };
        case "CLEAR_GENERATED_LINKEDIN_HEADSHOT":
            return {};
        default:
            return state;
    }
};

const fetchUserLinkedinHeadshots = (state = {}, action) => {
    switch (action.type) {
        case "FETCH_USER_LINKEDIN_HEADSHOTS_SUCCESS":
            state[action.key] = {
                isLoading: false,
                isError: false,
                isSuccess: true,
                searchLinkedinHeadshots: action.payload.searchResult,
                searchKey: action.payload.searchKey,
                totalSearchLinkedinHeadshots: action.payload.totalSearchResult,
            };
        default:
            return state;
    }
};

export default combineReducers({
    generateLinkedinHeadshot,
    fetchUserLinkedinHeadshots,
});
